module.exports = __webpack_public_path__ + "static/media/1.6e5f5e39.jpg";